import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const StyledLink = styled.a`
  color: ${uiToken.color.link.default};
  text-decoration: none;
  transition-duration: 0.2s;
  transition-property: color;
  transition-timing-function: ease-in-out;
  border-radius: 4px;

  &:hover {
    color: ${uiToken.color.link.hover};
  }

  &:active {
    color: ${uiToken.color.link.active};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${uiToken.color.border.glassActive};
    outline-offset: 2px;
  }
`;
